import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const Destinationcountry = {
  getList: async () => {
    const response = await apiService.get("/destinationcountries");

    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/destinationcountries/${id}`);
    return response.data;
  },
  getbySlug: async (id) => {
    const response = await apiService.get(
      `/destinationcountries/slug?slug=${id}`
    );
    return response.data;
  },
};

export default Destinationcountry;
